import React, { createContext, useContext } from 'react';

type Theme = 'light';

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
  setTheme: (theme: Theme) => void;
}

const ThemeContext = createContext<ThemeContextType>({
  theme: 'light',
  toggleTheme: () => {},
  setTheme: () => {},
});

export const useTheme = () => useContext(ThemeContext);

interface ThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Light-only ThemeProvider (Chevron brand requirement).
 * Kept as a thin wrapper so existing components don't need changes.
 */
export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <ThemeContext.Provider
      value={{ theme: 'light', toggleTheme: () => {}, setTheme: () => {} }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
